module.exports = __webpack_public_path__ + "img/the-constant-princess.8f1a76c1.png";